<template>
  <product-shop-the-look />
</template>
